import { Resources, useResource } from "Infrastructure/Translation/Resources";
import type { MarketEditTabs } from "Market/Components/Tabs/Hooks/useMarketEditTabs";
import { MarketPaths } from "Market/Routes/Routing";
import { MarketCardDefault } from "Market/Widgets/MarketCardDefault";
import { MarketEdit } from "Market/Widgets/MarketEdit";
import { MarketsList } from "Market/Widgets/MarketsList";
import { BlankCard } from "Shared/Components/Cards/BlankCard";
import Add from "@mui/icons-material/Add";
import {
	Button,
	Divider,
	Stack,
	type Theme,
	useMediaQuery,
} from "@mui/material";
import type { FC } from "react";
import { useNavigate } from "react-router";

type Props = {
	urlPath?: string;
	currentTab?: MarketEditTabs;
};

const marketResource = Resources.base.market.forms;

export const MarketsCard: FC<Props> = ({ urlPath, currentTab }) => {
	const { t } = useResource();
	const navigate = useNavigate();

	const isSmallScreen = useMediaQuery((theme: Theme) =>
		theme.breakpoints.down("sm"),
	);

	const handleNavigateCreateMarket = () => {
		navigate(MarketPaths.Create.route);
	};

	return (
		<BlankCard sx={{ p: 2 }}>
			<Stack flexDirection={{ xs: "column", md: "row" }}>
				<Stack
					width={{ xs: "100%", md: "270px" }}
					spacing={2}
					p={2}
					alignSelf="flex-start"
				>
					<Button
						variant="contained"
						onClick={handleNavigateCreateMarket}
						startIcon={<Add />}
					>
						{t(marketResource.add)}
					</Button>
					<MarketsList />
				</Stack>
				<Divider
					orientation={isSmallScreen ? "horizontal" : "vertical"}
					flexItem
				/>
				{urlPath && <MarketEdit urlPath={urlPath} currentTab={currentTab!} />}
				{!urlPath && <MarketCardDefault />}
			</Stack>
		</BlankCard>
	);
};
